export default __webpack_public_path__ + "static/media/next_push.233b404b.svg";